import React, { FC, ReactNode }      from 'react';
import { Container, Dimmer, Loader } from 'semantic-ui-react';
import classNames                    from 'classnames';
import { ClassValue }                from 'classnames/types';
import { StyledContainer }           from '../../../containers';

export interface LoadingIndicatorProps {
	label?: ReactNode,
	isActive?: boolean,
	inverted?: boolean,
	dimmer?: boolean,
	className?: ClassValue,
	
	[ additionalProps: string ]: any
}

const defaultProps: LoadingIndicatorProps = {
	label:     'Loading...',
	isActive:  false,
	inverted:  false,
	className: null,
	dimmer:    true,
}

const LoadingIndicator: FC<LoadingIndicatorProps> = ( props ) => {
	
	let { className, ...p } = props;
	
	let containerClasses = classNames(
		[ 'fade-in', 'padding-sm-horizontal', 'padding-md-vertical' ],
		className
	);
	
	if( !p.isActive ) return null;
	
	return (
		p.dimmer
		? <Dimmer active={ p.isActive } inverted={ p.inverted }>
			<StyledContainer className={ containerClasses }>
				<Loader inverted={ p.inverted }>{ p.label }</Loader>
			</StyledContainer>
		</Dimmer>
		: <StyledContainer className={ containerClasses }>
			<Loader active={ p.isActive } inverted={ p.inverted }>{ p.label }</Loader>
		</StyledContainer>
	);
	
};

LoadingIndicator.defaultProps = defaultProps;

export { LoadingIndicator }
